/* global axios */
import ApiClient from './ApiClient';

class TeamAssignmentAPI extends ApiClient {
  constructor() {
    super('teams', { accountScoped: true });
  }

  getConfig(teamId) {
    return axios.get(`${this.url}/${teamId}/assignment_config`);
  }

  updateConfig(teamId, assignmentConfig) {
    return axios.patch(`${this.url}/${teamId}/assignment_config`, {
      assignment_config: assignmentConfig,
    });
  }
}

export default new TeamAssignmentAPI();
